import { render, staticRenderFns } from "./CompanyAttendance.vue?vue&type=template&id=ab227d0e"
import script from "./CompanyAttendance.vue?vue&type=script&lang=js"
export * from "./CompanyAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports